module.exports = __webpack_public_path__ + "img/commtower.6f1bb5eb.svg";